import {resolveFactionSkinIconPath} from '../../../utils/factions/resolveFactionSkinIconPath';
import {getFactionConfig} from '../../../utils/factions/getFactionConfig';
import {getFactionSkinDisplayProps} from '../../../utils/factions/getFactionSkinDisplayProps';
import {getBotMarkIconPath} from '../../../utils/bots/getBotMarkIconPath';
import {checkIfBotMarkShown} from '../../../utils/bots/checkIfBotMarkShown';

export const SETUP_PLAYERS_MODAL_INITIATIVE_ICON_PATH = '/img/icons/initiative white.png';

// Иконка фракции в строке игрока — по выбранному скину
export const getSetupPlayerIconPath = (player) => (
  resolveFactionSkinIconPath(player.factionId, player.selectedSkin)
);

// Большая картинка фракции, которая проявляется после вылета строки игрока, —
// тоже по выбранному скину
export const getSetupPlayerFactionImagePath = (player) => (
  getFactionSkinDisplayProps(getFactionConfig(player.factionId), player.selectedSkin).imagePath
);

// Значок бота: на светлой плашке — вариант с черным контуром
export const getSetupPlayerBotIconPath = (player) => getBotMarkIconPath(player, true);

/**
 * Все картинки, которые SetupPlayersModal покажет для этого состава. Пути
 * берутся теми же функциями, что и в самой плашке, поэтому список не
 * разъедется с тем, что она рисует. Нужен тем, кто хочет прогрузить картинки
 * до начала анимации (витрина главного меню держит лоадер, пока они не готовы).
 *
 * @param {Array<Object>} players - игроки, которых покажет плашка
 * @param {{showVisibleBotMarks?: boolean}} [options] - как у SetupPlayersModal
 * @returns {string[]} уникальные непустые пути
 */
export const getSetupPlayersModalImagePaths = (players, {showVisibleBotMarks = false} = {}) => {
  if (!players || players.length === 0) {
    return [];
  }

  const paths = [SETUP_PLAYERS_MODAL_INITIATIVE_ICON_PATH];
  players.forEach((player) => {
    paths.push(getSetupPlayerIconPath(player), getSetupPlayerFactionImagePath(player));
    if (showVisibleBotMarks && checkIfBotMarkShown(player)) {
      paths.push(getSetupPlayerBotIconPath(player));
    }
  });

  return [...new Set(paths.filter(Boolean))];
};
